import { Button, Result } from 'antd';
import React from 'react';
import { useHistory } from 'react-router-dom';

const Error: React.FC = () => {
  const history = useHistory();

  //todo get french version using i18n => use translation
  return (
    <Result
      status="500"
      title="Something Wrong"
      subTitle="Sorry, something went wrong."
      extra={
        <Button
          type="primary"
          onClick={() => {
            history.push('/')
          }}
        >
          Reload
        </Button>
      }
    />
  );
};

export default Error;
